<template>
  <div class="container-fluid">
    <card-list/>

    <div class="row">
      <div class="col-md-6">
        <home-sales :height="400" ></home-sales>
      </div>

      <home-sales-payment></home-sales-payment>
    </div>
    <div class="row">
      <home-sales-groups></home-sales-groups>

      <products-most-saled></products-most-saled>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import cardList from '@/components/cardlists/dashFaturamento.vue'
import homeSales from '@/components/homeSales.vue'
import homeSalesPayment from '@/components/homeSalesPayment.vue'
import homeSalesGroups from '@/components/homeSalesGroups.vue'
import productsMostSaled from '@/components/grids/productsMostSaled.vue'

export default {
  name: 'vwDashFinanceiro',
  components: {
    cardList,
    homeSales,
    homeSalesPayment,
    homeSalesGroups,
    productsMostSaled
  }
}
</script>
<style scoped>
  .col-md-6,
  .col-md-4,
  .col-md-8{
    margin-bottom: 10px;
  }
</style>